import { Dispatch, MutableRefObject } from 'react';
import AlternatingService from '../ServiceStyle/AlternatingService';
import DefaultService from '../ServiceStyle/DefaultService';

const AlternatingStyle = ({
  services,
  organization,
  scrollElementRef,
}: {
  scrollElementRef: Dispatch<HTMLElement>;
  organization: any;
  services: any;
}) => {
  if (!services) return null;

  if (!(services instanceof Array)) return null;

  return (
    <div className="default-list-style">
      {services.map((service, index) =>
        index % 2 === 0 ? (
          <AlternatingService scrollElementRef={scrollElementRef} key={service.service.hash} service={service.service} organization={organization} />
        ) : (
          <DefaultService scrollElementRef={scrollElementRef} key={service.service.hash} service={service.service} organization={organization} />
        ),
      )}
    </div>
  );
};

export default AlternatingStyle;
